// Packages
import 'core-js';
import Vue from 'vue';
import { App, plugin } from '@inertiajs/inertia-vue';
import VueMeta from 'vue-meta';

// Global components
import LinkButton from '@/Components/Utils/LinkButton';
import Button from '@/Components/Utils/Button';

// CSS librarys
import '../css/tailwind.css';

// Icons
import iconsConfig from './icons.config';

iconsConfig();

// Vue settings
Vue.config.productionTip = false;
Vue.mixin({ methods: { route: window.route } });
Vue.use(plugin);
Vue.use(VueMeta);

Vue.component('LinkButton', LinkButton);
Vue.component('Button', Button);

// div with id "app" is injected by Inertia automatically
let el = document.getElementById('app');

new Vue({
  render: h =>
    h(App, {
      props: {
        initialPage: JSON.parse(el.dataset.page),
        resolveComponent: name =>
          import(`@/Pages/${name}`).then(module => module.default),
      },
    }),
}).$mount(el);
